<div class="body" *ngIf="widgetsReady">
    <div class="username-panel">Dashoboard von {{currentUsername}}</div>
    <app-widget-view-standalone [widgets]="widgets" (addWidgetAnchor)="widgetAdded($event)" (deleteWidgetAnchor)="widgetDeleted($event)"></app-widget-view-standalone>
</div>